var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"grid-card"},_vm._l((_vm.dataCard),function(card,index){return _c('Card',{key:index,attrs:{"discount":card.discount,"hitSales":card.hitSales,"brand":card.brand,"description":card.description,"price":card.price,"pastPrice":card.pastPrice,"inStock":card.inStock}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }